// Supplier feed templates for VELOTEKA product sync.
// Column list mirrors the backend `_apply_products_from_feed` parser.
// `supplier_price` is auto-marked-up by the configured multiplier (default 1.30 = 30%).
// Multiple images: pipe-separated in CSV, array in JSON, repeated <image> in XML.

const SAMPLE_ROWS = [
  {
    name: "Shimano XT M8100 Rear Derailleur",
    slug: "shimano-xt-m8100-rear-derailleur",
    category: "parts",
    subcategory: "drivetrain",
    brand: "Shimano",
    supplier_price: "89.00",
    stock: "15",
    condition: "new",
    wheel_size: "",
    frame_size: "",
    color: "Black",
    motor_brand: "",
    battery_capacity: "",
    suspension_travel: "",
    short_description: "12-speed Shadow RD+.",
    description: "Precise 12-speed shifting for MTB. Shadow RD+ chain stabilizer.",
    images: "https://images.unsplash.com/photo-1562615193-cbeef074a501?w=1200",
    featured: "false",
    best_seller: "true",
    new_arrival: "false",
  },
  {
    name: "Bosch PowerTube 625 Battery",
    slug: "bosch-powertube-625-battery",
    category: "parts",
    subcategory: "e-bike-parts",
    brand: "Bosch",
    supplier_price: "549.00",
    stock: "6",
    condition: "new",
    wheel_size: "",
    frame_size: "",
    color: "",
    motor_brand: "Bosch",
    battery_capacity: "625Wh",
    suspension_travel: "",
    short_description: "Genuine Bosch PowerTube 625Wh.",
    description: "OEM Bosch PowerTube 625Wh battery. Compatible with 2020+ Bosch systems.",
    images: "https://images.unsplash.com/photo-1562615193-cbeef074a501?w=1200",
    featured: "true",
    best_seller: "false",
    new_arrival: "true",
  },
];

const HEADERS = Object.keys(SAMPLE_ROWS[0]);

function csvEscape(v) {
  const s = String(v ?? "");
  if (s.includes(",") || s.includes('"') || s.includes("\n")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function buildCsvTemplate() {
  const lines = [HEADERS.join(",")];
  for (const row of SAMPLE_ROWS) {
    lines.push(HEADERS.map((h) => csvEscape(row[h])).join(","));
  }
  return lines.join("\n") + "\n";
}

export function buildJsonTemplate() {
  const objects = SAMPLE_ROWS.map((row) => {
    const obj = {};
    for (const h of HEADERS) {
      if (h === "images") {
        obj.images = String(row.images).split("|").filter(Boolean);
      } else if (h === "supplier_price") {
        obj.supplier_price = parseFloat(row.supplier_price);
      } else if (h === "stock") {
        obj.stock = parseInt(row.stock, 10);
      } else if (["featured", "best_seller", "new_arrival"].includes(h)) {
        obj[h] = row[h] === "true";
      } else {
        obj[h] = row[h];
      }
    }
    return obj;
  });
  return JSON.stringify({ products: objects }, null, 2) + "\n";
}

export function buildXmlTemplate() {
  const esc = (v) =>
    String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const rows = SAMPLE_ROWS.map((row) => {
    const cells = HEADERS.filter((h) => h !== "images").map((h) => `    <${h}>${esc(row[h])}</${h}>`);
    const images = String(row.images).split("|").filter(Boolean)
      .map((u) => `    <images>${esc(u)}</images>`);
    return `  <product>\n${cells.join("\n")}\n${images.join("\n")}\n  </product>`;
  });
  return `<?xml version="1.0" encoding="UTF-8"?>\n<products>\n${rows.join("\n")}\n</products>\n`;
}

export function downloadTemplate(kind) {
  let content, mime, filename;
  if (kind === "csv") {
    content = buildCsvTemplate();
    mime = "text/csv";
    filename = "veloteka-feed-template.csv";
  } else if (kind === "json") {
    content = buildJsonTemplate();
    mime = "application/json";
    filename = "veloteka-feed-template.json";
  } else {
    content = buildXmlTemplate();
    mime = "application/xml";
    filename = "veloteka-feed-template.xml";
  }
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const TEMPLATE_HEADERS = HEADERS;
